import breakpoint from 'styled-components-breakpoint';
import { rem } from 'polished';
import styled from 'styled-components';
import { theme } from 'styled-tools';

import BlockContent from '../BlockContent';

const PostArticle = styled.div`
  width: 100%;

  h1 {
    font-size: ${rem(32)};
  }

  h2 {
    font-size: ${rem(28)};
  }

  ul {
    li {
      strong {
        font-weight: bold;
      }
    }
  }

  blockquote {
    position: relative;
    border-top: 4px solid ${theme('colors.orange')};
    background-color: ${theme('colors.lightGray')};
    padding: 2rem 4rem 2rem 4rem;
    text-align: left;
    font-weight: normal;
    font-size: ${rem(20)};
    ${breakpoint('xs', 'sm')`
      font-size: ${rem(16)};
      padding: 2rem 2rem 2rem 2rem;
    `}

    p {
      position: relative;
      color: ${theme('colors.blue')};
      font-weight: normal;
      font-size: ${rem(20)};
      text-decoration: none;
      font-style: normal;
      line-height: ${rem(28)};
      text-align: left !important;

      ::before {
        position: absolute;
        top: 0.1em;
        left: -2rem;
        width: 25px;
        height: 20px;
        color: ${theme('colors.orange')};
        content: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS44NDkiIGhlaWdodD0iMjEuMTg5IiB2aWV3Qm94PSIwIDAgMjUuODQ5IDIxLjE4OSI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IDAuNjg5KSI+PHJlY3Qgd2lkdGg9IjI1IiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwKSIgZmlsbD0icmdiYSgwLDAsMCwwKSIvPjxwYXRoIGQ9Ik0xOS42MjIsMjBhNi41NDEsNi41NDEsMCwwLDEtMi43My0uNTIyLDQuMjgzLDQuMjgzLDAsMCwxLTEuODIzLTEuNTY2LDcuODU5LDcuODU5LDAsMCwxLTEuMDI3LTIuNDE3LDEyLjc2OSwxMi43NjksMCwwLDEtLjM0My0zLjA3Myw5LjMzNSw5LjMzNSwwLDAsMSwxLjAzNy00LjM4MSwxNS41ODcsMTUuNTg3LDAsMCwxLDIuNTE4LTMuNTMsMTguMjQzLDE4LjI0MywwLDAsMSwzLjIyMS0yLjdDMjEuNiwxLjA3OCwyMi41NTkuNDY4LDIzLjMyNSwwbDEuMzMzLDIuMjE4Yy0xLjE1Mi42NjEtMi4xLDEuMjM5LTIuODE0LDEuNzE5YTEzLDEzLDAsMCwwLTIuMTg0LDEuOSw4LjYyNyw4LjYyNywwLDAsMC0xLjYxMSwyLjM0NywxMC44NzMsMTAuODczLDAsMCwwLS43NTksMy4xMjRoMS43NzdhNS4zODgsNS4zODgsMCwwLDEsMy42MSwxLjEyOCwzLjUyNiwzLjUyNiwwLDAsMSwuOTg2LDEuMzkxLDUuMiw1LjIsMCwwLDEsLjMyOSwxLjkxOCw0LjM4LDQuMzgsMCwwLDEtMS4xNjYsMi45LDMuNzM0LDMuNzM0LDAsMCwxLTEuMzg0LDEuMDEyQTQuNjY4LDQuNjY4LDAsMCwxLDE5LjYyMiwyMFptLTEzLjcsMGE2LjU0MSw2LjU0MSwwLDAsMS0yLjczLS41MjJBNC4yODMsNC4yODMsMCwwLDEsMS4zNywxNy45MTEsNy44NTksNy44NTksMCwwLDEsLjM0MywxNS40OTUsMTIuNzY5LDEyLjc2OSwwLDAsMSwwLDEyLjQyMSw5LjMzNSw5LjMzNSwwLDAsMSwxLjAzNyw4LjA0MSwxNS41ODcsMTUuNTg3LDAsMCwxLDMuNTU0LDQuNTFhMTguMjQzLDE4LjI0MywwLDAsMSwzLjIyMS0yLjdDNy45LDEuMDc4LDguODYxLjQ2OCw5LjYyNiwwbDEuMzMzLDIuMjE4Yy0xLjE1Mi42NjEtMi4xLDEuMjM5LTIuODE0LDEuNzE5YTEzLjAwNiwxMy4wMDYsMCwwLDAtMi4xODQsMS45QTguNzM2LDguNzM2LDAsMCwwLDQuMzY5LDguMTdhMTAuNjY2LDEwLjY2NiwwLDAsMC0uNzc4LDMuMTQySDUuMzY4YTUuMzg4LDUuMzg4LDAsMCwxLDMuNjEsMS4xMjgsMy41MjYsMy41MjYsMCwwLDEsLjk4NiwxLjM5MSw1LjIsNS4yLDAsMCwxLC4zMjksMS45MTgsNC4zOCw0LjM4LDAsMCwxLTEuMTY2LDIuOSwzLjczNCwzLjczNCwwLDAsMS0xLjM4NCwxLjAxMkE0LjY2OCw0LjY2OCwwLDAsMSw1LjkyNCwyMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiNmYTc5M2EiIHN0cm9rZT0iI2ZhNzkzYSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjEiLz48L2c+PC9zdmc+);
      }

      em {
        font-weight: normal;
        font-size: ${rem(20)};
        text-decoration: none;
        font-style: normal;
      }

      em:first-of-type {
        background-color: unset !important;
        color: ${theme('colors.orange')};
      }

      em:last-of-type {
        display: block;
        background-color: unset !important;
        margin-top: 1rem;
        font-size: ${rem(16)};
        line-height: ${rem(26)};
      }
    }
  }
`;

const PostContent = ({ content }) => {
  return (
    <PostArticle>
      <BlockContent content={content} />
    </PostArticle>
  );
};

export default PostContent;
